import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Nav, Button, Badge } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useChat } from '../context/ChatContext';
import './MainLayout.scss';

export default function MainLayout() {
  const { user, logout } = useAuth();
  const { unreadCount } = useChat();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className={`main-layout ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      {/* Mobile Header */}
      <header className="mobile-header">
        <button className="menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <span className="hamburger"></span>
        </button>
        <span className="logo-text" onClick={() => { navigate('/dashboard'); closeMenu(); }} style={{ cursor: 'pointer' }}>StudyHelper</span>
        <div className="mobile-user-avatar" onClick={() => { navigate('/profile'); closeMenu(); }}>
          {user?.name?.[0]?.toUpperCase() || '?'}
        </div>
      </header>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

      {/* Seitenleiste */}
      <aside className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="logo-area">
          <span className="logo-text" onClick={() => { navigate('/dashboard'); closeMenu(); }} style={{ cursor: 'pointer' }}>StudyHelper</span>
          <button className="close-menu-btn" onClick={closeMenu}>&times;</button>
        </div>

        {/* Hauptnavigation */}
        <Nav className="flex-column nav-links">
          <Nav.Link as={NavLink} to="/dashboard" end className="nav-link" onClick={closeMenu}>
            <span>Dashboard</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/suche" className="nav-link" onClick={closeMenu}>
            <span>Dozenten finden</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/calendar" className="nav-link" onClick={closeMenu}>
            <span>Kalender</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/buchungen" className="nav-link" onClick={closeMenu}>
            <span>Meine Buchungen</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/chat/0" className="nav-link d-flex justify-content-between align-items-center" onClick={closeMenu}>
            <span>Nachrichten</span>
            {unreadCount > 0 && (
              <Badge pill bg="danger" style={{ fontSize: '0.7rem', padding: '0.35em 0.65em' }}>
                {unreadCount > 99 ? '99+' : unreadCount}
              </Badge>
            )}
          </Nav.Link>
          
          <div style={{ flexGrow: 1 }}></div>

          {user?.role === 'admin' && (
            <div className="admin-panel-section mt-auto mb-2">
              <div className="admin-panel-header px-3 py-1" style={{ fontSize: '0.75rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#b95c50' }}>
                Admin-Bereich
              </div>
              <Nav.Link as={NavLink} to="/admin/skills" className="nav-link py-1" onClick={closeMenu} style={{ paddingLeft: '25px', fontSize: '0.9rem' }}>
                <span>Skills verwalten</span>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/termine" className="nav-link py-1" onClick={closeMenu} style={{ paddingLeft: '25px', fontSize: '0.9rem' }}>
                <span>Termine verwalten</span>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/nutzer" className="nav-link py-1" onClick={closeMenu} style={{ paddingLeft: '25px', fontSize: '0.9rem' }}>
                <span>Nutzer verwalten</span>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/admin/tests" className="nav-link py-1" onClick={closeMenu} style={{ paddingLeft: '25px', fontSize: '0.9rem' }}>
                <span>System-Diagnose</span>
              </Nav.Link>
            </div>
          )}
          
          <Nav.Link as={NavLink} to="/settings" className={`nav-link ${user?.role === 'admin' ? '' : 'mt-auto'}`} onClick={closeMenu}>
            <span>Einstellungen</span>
          </Nav.Link>
        </Nav>

        {/* Benutzerbereich */}
        <div className="user-area" onClick={() => { navigate('/profile'); closeMenu(); }} style={{ cursor: 'pointer' }}>
          <div className="user-info">
            <div className="avatar">{user?.name?.[0]?.toUpperCase() || '?'}</div>
            <div className="user-details">
              <div className="user-name">{user?.name || 'Benutzer'}</div>
              <div className="user-email">{user?.email || ''}</div>
            </div>
          </div>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
            }}
            className="logout-button"
          >
            Abmelden
          </Button>
        </div>
      </aside>

      {/* Hauptinhalt */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
